import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { map, take } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { selectAuthClaims } from '../store/auth.store';
import { RootState } from '../../store/store.state';
import { ConfigManagerService } from '../../shared/services/config-manager.service';
import { ValidateJWTError } from '../store/auth.actions';
import { AuthErrorCode } from '../../../../common/models/auth-api.interface';
import { isArray, isObject } from 'lodash-es';

@Injectable()
export class AuthValidGuard implements CanActivate {
    protected framed: boolean = false;
    constructor(
        private store: Store<RootState>,
        private router: Router,
        private configManagerService: ConfigManagerService
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.store.pipe(
            select(selectAuthClaims),
            take(1),
            map(claims => {
                if (
                    claims === null ||
                    !isObject(claims) ||
                    !isArray(claims.enabled_sso_apps)
                ) {
                    /* skipLocationChange => Navigates without pushing a new state into history */
                    this.router.navigate(['/auth'], {
                        queryParams: {
                            qmReturnUrl: state.url,
                            framed: this.framed
                        },
                        skipLocationChange: true
                    });
                    return false;
                } else {
                    if (!this.isUserAuthorized(claims.enabled_sso_apps)) {
                        this.store.dispatch(
                            new ValidateJWTError({
                                authErrorCode: AuthErrorCode.UNAUTHORIZED,
                                framed: this.framed
                            })
                        );
                    }
                    return true;
                }
            })
        );
    }

    isUserAuthorized(enabledApps: string[]): boolean {
        return enabledApps.includes(this.configManagerService.ssoConfig.appKey);
    }
}
